import { useTranslation } from 'react-i18next';
import { Command } from 'cmdk';

import { MagicSearchStatusProps } from '../magic-search-palette.type';

import { MagicSearchScopes } from './magic-search-scopes';

const STATUS_CLASS = 'flex flex-col items-center gap-1 px-3 py-10 text-center text-body-s text-tertiary';

export const MagicSearchStatus = ({ typedTerm, isSearchable, isLoading, isError, isEmpty }: MagicSearchStatusProps) => {
  const { t } = useTranslation();

  if (isError) {
    return (
      <p className={STATUS_CLASS} data-testid='magic-search--error'>
        {t('errors:genericError')}
      </p>
    );
  }
  if (typedTerm === '') return <MagicSearchScopes />;
  if (!isSearchable) {
    return (
      <p className={STATUS_CLASS} data-testid='magic-search--hint'>
        {t('menu:magicSearchMinLength')}
      </p>
    );
  }
  if (isLoading) {
    return (
      <Command.Loading label='Searching' className={STATUS_CLASS} data-testid='magic-search--loading'>
        {t('menu:magicSearchLoading')}
      </Command.Loading>
    );
  }
  if (isEmpty) {
    return (
      <Command.Empty className={STATUS_CLASS} data-testid='magic-search--no-results'>
        <span className='text-subtitle-s text-secondary'>{t('menu:magicSearchNoResults', { term: typedTerm })}</span>
        <span>{t('menu:magicSearchNoResultsHint')}</span>
      </Command.Empty>
    );
  }
  return null;
};
